module.exports = __webpack_public_path__ + "static/media/service-main-3.e09f49ea.svg";